import styled, {css, SimpleInterpolation} from "styled-components";
import THEME from "../../assets/styles/config";
import Media from "../../assets/styles/media";

interface SearchTabProps {
  show?: boolean;
}

export const SearchTabCtn = styled.div<SearchTabProps>`
  border-bottom: grey 1px solid;
  background-color: white;
  height: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 130, 189, 0.2);
  position: relative;
  max-width: 80px;
  padding: 55px 0;
  transition: all 0.5s ease-in-out;
  cursor: pointer;

  ${(props): SimpleInterpolation =>
  css &&
  props.show &&
  `
      max-width: 480px;
      padding: 55px 50px 55px 4vw;
      cursor: default;

      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        max-width: unset;
        position: fixed;
        top: 0;
        z-index: 5;
        overflow: auto;
        padding: 30px;
      }

      @media screen and (max-width: ${THEME.layout.mobileLarge.breakpoint}px) {
        padding: 15px;
        z-index: 200;
      }
    `};

  ${(props): SimpleInterpolation =>
  css &&
  !props.show &&
  `
      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        display: none;
      }
    `};

  > span {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;

    ${(props): SimpleInterpolation =>
  css &&
  props.show &&
  `
      opacity: 0;
    `};
  }
`;

export const CloseBtn = styled.div<SearchTabProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  border-radius: 34px;
  background-color: white;
  position: absolute;
  right: -17px;
  box-shadow: 0 3px 10px 0 rgba(0, 130, 189, 0.2);
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.5s ease-in-out;
  z-index: 10;

  > svg {
    stroke: ${THEME.colors.primaryColor};
  }

  ${(props): SimpleInterpolation =>
  css &&
  props.show &&
  `
      transform: rotate(180deg);
    `};

  ${Media.Below.desktopLarge`
    display: none;
  `}
`;

export const SearchCriteriaCloseText = styled.span`
  font-weight: bold;
  width: 120px;
  transform: rotate(-90deg);
  position: absolute;
  left: -18px;
  top: 95px;

  ${Media.Below.desktopLarge`
    display: none;
  `}
`;

export const OverflowCtn = styled.div<SearchTabProps>`
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out;
  overflow: visible;

  ${Media.Below.desktopLarge`
    height: 100%;
  `}

  ${(props): SimpleInterpolation =>
  css &&
  props.show &&
  `
      opacity: 1;
      visibility: initial;
    `};
`;

export const TabletOpenBtn = styled.div`
  display: none;
  width: 100%;
  padding: 10px 20px;

  > button {
    cursor: pointer;
    color: ${THEME.colors.primaryFontColor};
    font-size: 16px;
    font-weight: bold;
    background-color: transparent;
    border: ${THEME.colors.primaryFontColor} 1px solid;
    width: 100%;
    height: 40px;

    ${Media.Below.mobileLarge`
      font-size: 12px;
    `}
  }

  ${Media.Below.desktopLarge`
    display: flex;
  `}
`;

export const ButtonCtn = styled.div`
  min-width: 250px;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;

  ${Media.Below.desktopLarge`
    position: absolute;
    bottom: 0;  
    margin-top: 0;
  `}

  ${Media.Below.mobileLarge`
    position: static;
    margin-top: 0;
  `}
`;

export const CancelBtn = styled.button`
  font-weight: bold;
  background-color: white;
  color: ${THEME.colors.primaryFontColor};
  border: ${THEME.colors.primaryFontColor} 1px solid;
  height: 40px;
  cursor: pointer;

  ${Media.Below.desktopLarge`
    flex: 0 1 45%;
    display: flex;
    justify-content: center;
  `}
`;

export const ApplyBtn = styled.input`
  font-weight: bold;
  color: white;
  text-align: center;
  height: 40px;
  background-color: ${THEME.colors.primaryColor};
  width: 50%;
  cursor: pointer;

  ${Media.Below.desktopLarge`
    flex: 0 1 45%;
  `}
`;